// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__1CSJc","label":"Radio_label__1D5Qb","checkMark":"Radio_checkMark__jUlu7","disabled":"Radio_disabled__2bSju"};